import { Helmet } from 'react-helmet-async';
import * as React from 'react';
import { faker } from '@faker-js/faker';
import { sample } from 'lodash';
import { useNavigate, Link } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LineStyleIcon from '@mui/icons-material/LineStyle';
import moment from 'moment';
import {
  Grid,
  Container,
  Typography,
  Stack,
  CardActionArea,
  CardActions,
  Button,
  Paper,
  IconButton,
} from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import Row from 'react-bootstrap/Row';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useTheme, styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { getFullname } from '../utils/common';
import {
  AppNewsUpdate,
  AppWebsiteVisits,
  AppCurrentVisits,
  AppTasks,
  AppWidgetSummary,
} from '../sections/@dashboard/app';
import {
  getToken,
  removeUserSession,
  tokenIsExpired,
  refreshTokenIsExpired,
  getRefreshToken,
  renewToken,
  setRefreshUserSession,
} from '../utils/common';
import CalendarPage from './calendar/calendarcustomDashboard';
import Footer from './footer';

// ----------------------------------------------------------------------

export default function DashboardAppPage() {
  const [outputProcessed, setOutputProcessed] = React.useState('Monthly');
  const [outputAuth, setOutputAuth] = React.useState('Monthly');
  const [outputunAuth, setOutputunAuth] = React.useState('Monthly');
  const [dataalert, setDataAlert] = React.useState([]);
  const [DataPieChart, setDataPieChart] = React.useState([]);
  const [datalengs, setdatalengs] = React.useState([]);
  const [dataFraud, setdataFraud] = React.useState([]);
  const [dataNotFraud, setdataNotFraud] = React.useState([]);
  const [dataNotFraudmonthly, setdataNotFraudmonthly] = React.useState([]);
  const [dataFraudmonthly, setdataFraudmonthly] = React.useState([]);
  const [dataFraudweekly, setdataFraudweekly] = React.useState([]);
  const [bulletin, setbulletin] = React.useState([]);
  const [dataNotFraudweekly, setdataNotFraudweekly] = React.useState([]);
  const [data2, setData2] = React.useState([]);
  const [dayname, setdayname] = React.useState([]);
  const [monthname, setmothname] = React.useState([]);
  const [weekname, setweekname] = React.useState([]);
  const [datasetdaily, setdatasetdaily] = React.useState([]);
  const [datasetmonthly, setdatasetmonthly] = React.useState([]);
  const [datasetweekly, setdatasetweekly] = React.useState();

  const [datasetdaily2, setdatasetdaily2] = React.useState([]);
  const [datasetmonthly2, setdatasetmonthly2] = React.useState([]);
  const [datasetweekly2, setdatasetweekly2] = React.useState();
  const [user, setuser] = React.useState(getFullname());
  const [dataTotal, setDataTotal] = React.useState({
    open: 0,
    inProgress: 0,
    penddingApproval: 0,
    penddingRollback: 0,
  });

  function convertToFormattedDate(inputString) {
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    const parts = inputString.split(' ');
    const monthName = parts[0];
    const year = parts[1];

    const monthIndex = monthNames.indexOf(monthName) + 1;
    const formattedMonth = String(monthIndex).padStart(2, '0');

    return `${year}-${formattedMonth}`;
  }
  const handleChangeAuth = (event) => {
    setOutputAuth(event.target.value);
  };
  const handleChangeunAuth = (event) => {
    setOutputunAuth(event.target.value);
  };
  const handleChangeProcessed = (event) => {
    setOutputProcessed(event.target.value);
  };
  const navigate = useNavigate();
  const handleClickers = () => {
    navigate('/dashboard/blog', { replace: true });
  };
  const theme = useTheme();

  const fetchInfo = (url, set) => {
    return fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        set(d);
      });
  };

  function isBetween(checkDate, startDate, endDate) {
    return checkDate >= startDate && checkDate <= endDate;
  }

  function getWeekForDate(dateToCheck, weekDates) {
    // const currentDateFormatted = dateToCheck.toISOString().slice(0, 10);
    for (let i = 0; i < weekDates.length; i += 1) {
      const startDate = new Date(weekDates[i]);
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);

      if (isBetween(dateToCheck, startDate, endDate)) {
        return i;
      }
    }

    return null;
  }
  const urlpiechart = window.REACT_APP_API_PURE + 'dashboard/list?type=1';

  const fetchInfo2 = () => {
    return fetch(urlpiechart, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        setDataTotal({
          ...dataTotal,
          open: d?.filter((val) => val?.status === 'open')[0]?.total || 0,
          inProgress: d?.filter((val) => val?.status === 'inProgress')[0]?.total || 0,
          penddingApproval: d?.filter((val) => val?.status === 'pendingApproval')[0]?.total || 0,
          penddingRollback: d?.filter((val) => val?.status === 'pendingRollback')[0]?.total || 0,
        });
      });
  };
  function formatDateToYYYYMMDD(utcDateString) {
    const date = new Date(utcDateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const fetchInfo3 = (url, set1, set2, sevenDaysBeforeDates = []) => {
    return fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        setdata(url, 'rollback', d, set1, sevenDaysBeforeDates);
        setdata(url, 'keep', d, set2, sevenDaysBeforeDates);
      });
  };
  const fetchInfo4 = (url, set1, sevenDaysBeforeDates = []) => {
    return fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        setdata2(
          url,
          d.filter((val) => val?.status === 'authorized'),
          set1,
          sevenDaysBeforeDates
        );
      });
  };
  const fetchInfo5 = (url, set1, sevenDaysBeforeDates = []) => {
    return fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        setdata2(
          url,
          d.filter((val) => val?.status === 'unauthorized'),
          set1,
          sevenDaysBeforeDates
        );
      });
  };

  const setdata2 = (url, data, set, sevenDaysBeforeDates) => {
    const removepath = data;
    if (url === window.REACT_APP_API_PURE + 'dashboard/list?type=3&duration=daily') {
      const intArray = sevenDaysBeforeDates.map((obj) => {
        const remo = removepath?.filter((objj) => formatDateToYYYYMMDD(objj.date) === obj.date);
        if (remo.length !== 0) {
          return parseInt(remo[0].total, 10);
        }
        return 0;
      });
      set(intArray);
    } else if (url === window.REACT_APP_API_PURE + 'dashboard/list?type=3&status=Fraud&duration=monthly') {
      const intArray = sevenDaysBeforeDates.map((obj) => {
        const remo = removepath?.filter((objj) => objj.date === convertToFormattedDate(obj));
        if (remo.length !== 0) {
          return parseInt(remo[0].total, 10);
        }
        return 0;
      });
      set(intArray);
    } else if (url === window.REACT_APP_API_PURE + 'dashboard/list?type=3&duration=weekly') {
      let number1 = 0;
      let number2 = 0;
      let number3 = 0;
      let number4 = 0;

      // const intArray = sevenDaysBeforeDates.map((obj) => {
      //   const remo = removepath?.filter((objj) => objj.date === convertToFormattedDate(obj));
      //   if (remo.length !== 0) {
      //     return parseInt(remo[0].total, 10);
      //   }
      //   return 0;
      // });

      const weeklyTotals = [0, 0, 0, 0]; // Initialize an array to hold totals for 4 weeks
      removepath.forEach((obj) => {
        const log = getWeekForDate(new Date(formatDateToYYYYMMDD(obj.date)), sevenDaysBeforeDates);
        if (log >= 0 && log < 4) {
          // Ensure log is within the 0-3 range
          weeklyTotals[log] += parseInt(obj.total, 10); // Add to the respective week's total
        }
      });
      [number1, number2, number3, number4] = weeklyTotals; // Assign the totals to the respective variables
      set([number1, number2, number3, number4]);
    } else {
      const intArray = removepath.map((obj) => parseInt(obj.total, 10));

      set(intArray);
    }
  };

  const { t } = useTranslation();

  function handleClickLang(lang) {
    i18next.changeLanguage(lang);
  }
  const setdata = (url, tittle, data, set, sevenDaysBeforeDates) => {
    const removepath = data?.filter((val) => val?.status === tittle);
    if (url === window.REACT_APP_API_PURE + 'dashboard/list?type=2&duration=daily') {
      const intArray = sevenDaysBeforeDates?.map((obj) => {
        const remo = removepath?.filter((objj) => formatDateToYYYYMMDD(objj.date) === obj.date);
        if (remo?.length !== 0) {
          return parseInt(remo && remo[0]?.total, 10);
        }
        return 0;
      });
      set(intArray);
    } else if (url === window.REACT_APP_API_PURE + 'dashboard/list?type=2&duration=monthly') {
      const intArray = sevenDaysBeforeDates.map((obj) => {
        const remo = removepath?.filter((objj) => objj.date === convertToFormattedDate(obj));
        if (remo?.length !== 0) {
          return parseInt(remo && remo[0]?.total, 10);
        }
        return 0;
      });
      set(intArray);
    } else if (url === window.REACT_APP_API_PURE + 'dashboard/list?type=2&duration=daily?limit=1000') {
      let number1 = 0;
      let number2 = 0;
      let number3 = 0;
      let number4 = 0;

      removepath?.map((obj) => {
        const log = getWeekForDate(new Date(formatDateToYYYYMMDD(obj.date)), sevenDaysBeforeDates);
        if (log === 0) {
          number1 += parseInt(obj.total, 10);
        } else if (log === 1) {
          number2 += parseInt(obj.total, 10);
        } else if (log === 2) {
          number3 += parseInt(obj.total, 10);
        } else if (log === 3) {
          number4 += parseInt(obj.total, 10);
        }
        return obj;
      });

      // const intArray = sevenDaysBeforeDates.map((obj) => {

      //   // if (remo.length !== 0) {
      //   //   return parseInt(remo[0].total, 10);
      //   // }
      //   // return 0;
      //   return obj;
      // });
      set([number1, number2, number3, number4]);
    } else {
      const intArray = removepath.map((obj) => parseInt(obj.total, 10));

      set(intArray);
    }
  };
  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  useEffect(() => {
    fetchInfo(window.REACT_APP_API_PURE + 'alert/list', setDataAlert);
    fetchInfo(window.REACT_APP_API_PURE + 'reference/list?kode=F003', setData2);
    fetchInfo2();

    const currentDate = new Date();
    const daysBefore = 7; // Number of days before the current date
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const sevenDaysBeforeDates = [];
    const monthNamesArray = [];

    for (let i = daysBefore - 1; i >= 0; i -= 1) {
      const date = new Date(currentDate);
      date.setDate(currentDate.getDate() - i);
      const dayName = daysOfWeek[date.getDay()];
      const formattedDate = date.toISOString().slice(0, 10);
      sevenDaysBeforeDates.push({ date: formattedDate, day: dayName });
      setdayname((prevArray) => [...prevArray, dayName + formattedDate.slice(4).replace('-', '/')]);
      const monthIndex = (currentMonth - i + 12) % 12; // Handle wrapping around to the previous year
      const monthName = monthNames[monthIndex];
      const year = monthIndex <= currentMonth ? currentYear : currentYear - 1;
      const formattedMonthYear = `${monthName} ${year}`;
      monthNamesArray.push(formattedMonthYear);
      setmothname((prevArray) => [...prevArray, formattedMonthYear]);
    }

    const weeksBefore = 4; // Number of weeks before the current date
    const weekDates = [];

    for (let i = weeksBefore - 1; i >= 0; i -= 1) {
      const date = new Date();
      date.setDate(date.getDate() - i * 7); // Subtract i weeks from current date

      // Move date to the previous Monday
      while (date.getDay() !== 1) {
        date.setDate(date.getDate() - 1);
      }

      const formattedDate = formatDate(date);
      const weekLabel = `${formattedDate}`;
      weekDates.push(weekLabel);
      setweekname((prevArray) => [...prevArray, weekLabel]);
    }


    fetchInfo3(
      window.REACT_APP_API_PURE + 'dashboard/list?type=2&duration=daily',
      setdataFraud,
      setdataNotFraud,
      sevenDaysBeforeDates
    );
    fetchInfo3(
      window.REACT_APP_API_PURE + 'dashboard/list?type=2&duration=monthly',
      setdataFraudmonthly,
      setdataNotFraudmonthly,
      monthNamesArray
    );
    fetchInfo3(
      window.REACT_APP_API_PURE + 'dashboard/list?type=2&duration=daily?limit=1000',
      setdataFraudweekly,
      setdataNotFraudweekly,
      weekDates
    );

    fetchInfo4(
      window.REACT_APP_API_PURE + 'dashboard/list?type=3&duration=daily',
      setdatasetdaily,
      sevenDaysBeforeDates
    );
    fetchInfo4(
      window.REACT_APP_API_PURE + 'dashboard/list?type=3&status=Fraud&duration=monthly',
      setdatasetmonthly,
      monthNamesArray
    );
    fetchInfo4(window.REACT_APP_API_PURE + 'dashboard/list?type=3&duration=weekly', setdatasetweekly, weekDates);

    fetchInfo5(
      window.REACT_APP_API_PURE + 'dashboard/list?type=3&duration=daily',
      setdatasetdaily2,
      sevenDaysBeforeDates
    );
    fetchInfo5(
      window.REACT_APP_API_PURE + 'dashboard/list?type=3&status=Fraud&duration=monthly',
      setdatasetmonthly2,
      monthNamesArray
    );
    fetchInfo5(window.REACT_APP_API_PURE + 'dashboard/list?type=3&duration=weekly', setdatasetweekly2, weekDates);
  }, []);

  const [totalCount, setTotalCount] = useState([]);
  const [totalCount1, setTotalCount1] = useState([]);
  const [totalCount2, setTotalCount2] = useState([]);

  const urlopen = window.REACT_APP_API_PURE + 'dashboard/list?type=1';

  const datalength = () => {
    return fetch(urlopen, {
      headers: {
        Authorization: `Bearer ${getToken}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        const updatedData = d.map((item) => {
          if (item.status === 'Process') {
            return { ...item, status: 'In Progress' };
          }

          return item;
        });
        const filteropen = updatedData?.filter((item) => item.status === 'Open');
        const filterinprogress = updatedData?.filter((item) => item.status === 'In Progress');
        const filterpending = updatedData?.filter((item) => item.status === 'Pending Approval');
        const data = [
          {
            status: 'Open',
            total: parseInt(filteropen[0]?.total, 10) || 0,
          },
        ];
        const data1 = [
          {
            status: 'In Progress',
            total: parseInt(filterinprogress[0]?.total, 10) || 0,
          },
        ];
        const data2 = [
          {
            status: 'Pending Approval',
            total: parseInt(filterpending[0]?.total, 10) || 0,
          },
        ];
        setTotalCount(data);
        setTotalCount1(data1);
        setTotalCount2(data2);
        // Update the state with the count
      });
  };

  return (
    <>
      <Helmet>
        <title>Dashboard | SmartShield</title>
      </Helmet>
      {/* <Button onClick={() => handleClickLang('en')}>English</Button>
      <Button onClick={() => handleClickLang('ind')}>Bahasa Indonesia</Button> */}
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Hi, {t('Welcome.1')} {user || ''}
        </Typography>
        <div className="flex flex-col space-y-5 ...">
          <div className="grid grid-rows-3 grid-flow-col gap-5 flex flex-col space-y-4">
            <div className="row-start-1 row-end-4 pt-4 ...">
              <Grid container spacing={3} justify="center" alignItems="center">
                <Grid item xs={2} sm={2} md={3}>
                  <Link
                    to={{
                      pathname: `/dashboard/alert`,
                      search: `?id=${0}`,
                    }}
                    state={{ index: 0 }}
                  >
                    <AppWidgetSummary
                      title="Open"
                      total={dataTotal.open}
                      color="error"
                      icon={'ant-design:android-filled'}
                    />
                  </Link>
                </Grid>

                <Grid item xs={2} sm={2} md={3}>
                  <Link
                    to={{
                      pathname: `/dashboard/alert`,
                      search: `?id=${1}`,
                    }}
                    state={{ index: 1 }}
                  >
                    <AppWidgetSummary
                      title="In Progress"
                      total={dataTotal.inProgress}
                      color="warning"
                      icon={'ant-design:apple-filled'}
                    />
                  </Link>
                </Grid>
                <Grid item xs={6} sm={2} md={3}>
                  <Link
                    to={{
                      pathname: `/dashboard/alert`,
                      search: `?id=${2}`,
                    }}
                    state={{ index: 2 }}
                  >
                    <AppWidgetSummary
                      title="Pending Approval"
                      total={dataTotal.penddingApproval}
                      color="info"
                      icon={'ant-design:windows-filled'}
                    />
                  </Link>
                </Grid>

                <Grid item xs={6} sm={2} md={3}>
                  <Link
                    to={{
                      pathname: `/dashboard/alert`,
                      search: `?id=${3}`,
                    }}
                    state={{ index: 3 }}
                  >
                    <AppWidgetSummary
                      title="Pending Rollback"
                      total={dataTotal.penddingRollback}
                      icon={'ant-design:bug-filled'}
                    />
                  </Link>
                </Grid>
              </Grid>
            </div>
          </div>

          <Grid container spacing={2}>
            <Grid item xs={12} md={3} lg={6}>
              <Card>
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                  <InputLabel id="demo-select-small-label">{t('TimeSpan.1')}</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={outputAuth}
                    label="Time Span"
                    onChange={handleChangeAuth}
                  >
                    <MenuItem value={t('Monthly.1')}>{t('Monthly.1')}</MenuItem>
                    <MenuItem value={t('Weekly.1')}>{t('Weekly.1')}</MenuItem>
                    <MenuItem value={t('Daily.1')}>{t('Daily.1')}</MenuItem>
                  </Select>
                </FormControl>
                {/* <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                  <InputLabel id="demo-select-small-label">{t('Alert.1')}</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={output1}
                    label="Alert"
                    onChange={handleChange1}
                  >
                    <MenuItem value={t('AlertDataset.1')}>{t('AlertDataset.1')}</MenuItem>
                    <MenuItem value={t('AlertProcessed.1')}>{t('AlertProcessed.1')}</MenuItem>
                  </Select>
                </FormControl> */}
                {/* <Grid item xs={12} md={6} lg={8}> */}
                <AppWebsiteVisits
                  title={t('authorizedUpdates.1')}
                  subheader={outputAuth}
                  chartLabels={
                    outputAuth === t('Monthly.1')
                      ? monthname
                      : outputAuth === t('Weekly.1')
                      ? weekname
                      : outputAuth === t('Daily.1')
                      ? dayname
                      : ['']
                  }
                  chartData={
                    outputAuth === t('Monthly.1')
                      ? [
                          {
                            name: 'Authorized',
                            type: 'bar',
                            fill: 'solid',
                            data: datasetmonthly,
                          },
                        ]
                      : outputAuth === t('Weekly.1')
                      ? [
                          {
                            name: 'Authorized',
                            type: 'bar',
                            fill: 'solid',
                            data: datasetweekly,
                          },
                        ]
                      : outputAuth === t('Daily.1')
                      ? [
                          {
                            name: 'Authorized',
                            type: 'bar',
                            fill: 'solid',
                            data: datasetdaily,
                          },
                        ]
                      : [
                          {
                            name: 'empty',
                          },
                        ]
                  }
                />
              </Card>
            </Grid>

            <Grid item xs={12} md={3} lg={6}>
              <Card>
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                  <InputLabel id="demo-select-small-label">{t('TimeSpan.1')}</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={outputunAuth}
                    label="Time Span"
                    onChange={handleChangeunAuth}
                  >
                    <MenuItem value={t('Monthly.1')}>{t('Monthly.1')}</MenuItem>
                    <MenuItem value={t('Weekly.1')}>{t('Weekly.1')}</MenuItem>
                    <MenuItem value={t('Daily.1')}>{t('Daily.1')}</MenuItem>
                  </Select>
                </FormControl>
                {/* <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                  <InputLabel id="demo-select-small-label">{t('Alert.1')}</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value="{output1}"
                    label="Alert"
                    onChange={handleChange1}
                  >
                    <MenuItem value={t('AlertDataset.1')}>{t('AlertDataset.1')}</MenuItem>
                    <MenuItem value={t('AlertProcessed.1')}>{t('AlertProcessed.1')}</MenuItem>
                  </Select>
                </FormControl> */}
                {/* <Grid item xs={12} md={6} lg={8}> */}
                <AppWebsiteVisits
                  title={t('unauthorizedUpdates.1')}
                  subheader={outputunAuth}
                  chartLabels={
                    outputunAuth === t('Monthly.1')
                      ? monthname
                      : outputunAuth === t('Weekly.1')
                      ? weekname
                      : outputunAuth === t('Daily.1')
                      ? dayname
                      : ['']
                  }
                  chartData={
                    outputunAuth === t('Monthly.1')
                      ? [
                          {
                            name: 'Unauthorized',
                            type: 'bar',
                            fill: 'solid',
                            data: datasetmonthly2,
                          },
                        ]
                      : outputunAuth === t('Weekly.1')
                      ? [
                          {
                            name: 'Unauthorized',
                            type: 'bar',
                            fill: 'solid',
                            data: datasetweekly2,
                          },
                        ]
                      : outputunAuth === t('Daily.1')
                      ? [
                          {
                            name: 'Unauthorized',
                            type: 'bar',
                            fill: 'solid',
                            data: datasetdaily2,
                          },
                        ]
                      : [
                          {
                            name: 'empty',
                          },
                        ]
                  }
                />
              </Card>
            </Grid>
            <Grid item xs={12} md={3} lg={6}>
              <Card>
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                  <InputLabel id="demo-select-small-label">{t('TimeSpan.1')}</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={outputProcessed}
                    label="Time Span"
                    onChange={handleChangeProcessed}
                  >
                    <MenuItem value={t('Monthly.1')}>{t('Monthly.1')}</MenuItem>
                    <MenuItem value={t('Weekly.1')}>{t('Weekly.1')}</MenuItem>
                    <MenuItem value={t('Daily.1')}>{t('Daily.1')}</MenuItem>
                  </Select>
                </FormControl>
                {/* <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                  <InputLabel id="demo-select-small-label">{t('Alert.1')}</InputLabel>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={output1}
                    label="Alert"
                    onChange={handleChange1}
                  >
                    <MenuItem value={t('AlertDataset.1')}>{t('AlertDataset.1')}</MenuItem>
                    <MenuItem value={t('AlertProcessed.1')}>{t('AlertProcessed.1')}</MenuItem>
                  </Select>
                </FormControl> */}
                {/* <Grid item xs={12} md={6} lg={8}> */}
                <AppWebsiteVisits
                  title="Processed Alerts"
                  subheader={outputProcessed}
                  chartLabels={
                    outputProcessed === t('Monthly.1')
                      ? monthname
                      : outputProcessed === t('Weekly.1')
                      ? weekname
                      : outputProcessed === t('Daily.1')
                      ? dayname
                      : ['']
                  }
                  chartData={
                    outputProcessed === t('Monthly.1')
                      ? [
                          {
                            name: 'Rollback',
                            type: 'bar',
                            fill: 'solid',
                            data: dataFraudmonthly,
                          },
                          {
                            name: 'Keep',
                            type: 'bar',
                            fill: 'solid',
                            data: dataNotFraudmonthly,
                          },
                        ]
                      : outputProcessed === t('Weekly.1')
                      ? [
                          {
                            name: 'Rollback',
                            type: 'bar',
                            fill: 'solid',
                            data: dataFraudweekly,
                          },
                          {
                            name: 'Keep',
                            type: 'bar',
                            fill: 'solid',
                            data: dataNotFraudweekly,
                          },
                        ]
                      : outputProcessed === t('Daily.1')
                      ? [
                          {
                            name: 'Rollback',
                            type: 'bar',
                            fill: 'solid',
                            data: dataFraud,
                          },
                          {
                            name: 'Keep',
                            type: 'bar',
                            fill: 'solid',
                            data: dataNotFraud,
                          },
                        ]
                      : [
                          {
                            name: 'empty',
                          },
                        ]
                  }
                />
              </Card>
            </Grid>
            <Grid item xs={12} md={3} lg={6}>
              <Card>
                <CalendarPage />
              </Card>
            </Grid>
          </Grid>
          {/* <Grid item xs={8} md={2} lg={8}>
            <AppCurrentVisits
              title={t('ActiveAlerts.1')}
              chartData={DataPieChart || []}
              chartColors={[theme.palette.primary.red, theme.palette.secondary.orane, theme.palette.info.blue]}
            />
          </Grid> */}

          {/* <Grid container direction={'row'} xs={12} spacing={2}>
            {bulletin.data?.map((item, itemIndex) => (
              <Grid item xs={5}>
                <Card sx={{ maxWidth: 455 }}>
                  <CardActionArea>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        {item?.tittle}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {item?.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <Grid container direction={'row'} justifyContent={'space-between'}>
                      <Grid item>
                        {' '}
                        <Button size="small" color="primary" onClick={handleClickers}>
                        {t('Bulletins.1')}
                        </Button>
                      </Grid>
                      <Grid item>
                        <Typography variant="caption">
                          {' '}
                          {moment.unix(item.created_at).format('YYYY-MM-DD HH:mm')}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid> */}
        </div>
      </Container>
    </>
  );
}
